module.exports = __webpack_public_path__ + "static/media/add-event.459694a3.png";